"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.deployUtils = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../common/localizeUtils");
const constants_1 = require("./constants");
class DeployUtils {
    async askForDeployConsentV3(ctx) {
        var _a;
        const msg = (0, localizeUtils_1.getLocalizedString)("core.deploy.confirmEnvNoticeV3", process.env.TEAMSFX_ENV);
        const deployOption = (0, localizeUtils_1.getLocalizedString)("core.option.deploy");
        const result = await ((_a = ctx.ui) === null || _a === void 0 ? void 0 : _a.showMessage("warn", msg, true, deployOption));
        const choice = (result === null || result === void 0 ? void 0 : result.isOk()) ? result.value : undefined;
        if (choice === deployOption) {
            return (0, teamsfx_api_1.ok)(teamsfx_api_1.Void);
        }
        return (0, teamsfx_api_1.err)(new teamsfx_api_1.UserError(constants_1.SolutionSource, "UserCancel", "UserCancel"));
    }
}
exports.deployUtils = new DeployUtils();
//# sourceMappingURL=deployUtils.js.map